import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Card, Col, Container, Form, Image, Row } from "react-bootstrap";
import Cart from "../Cart/Cart";
import "./Verify.scss";
import { config } from "../../config";
import { useLocation, useNavigate } from "react-router-dom";
import { CartData } from "../../interfaces/CartData";
import { useCart } from "../../services/cartService";
import nvCookieHelpers from "../../services/cookieService";
import { useHeaderMenu } from "../../contexts/login.context";
import Spinner from "../Spinner/Spinner";
import useLoader from "../../contexts/LoaderContext";
// @ts-ignore - gif file type declaration
import cartLoader from '../../assets/images/cart_Loader.gif';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from "react-i18next";
import DOMPurify from 'dompurify';
import { sanitizePhoneNo, formatPhoneNoInReadableForm, isJwtTokenExpired } from '../../helpers/common';
import { useLocalization } from '../../contexts/LocalizationContext';
import ErrorModal from "../ErrorModal/ErrorModal";
import { initialize } from "@nv-ces/ucp-wrapper";
import { v4 as uuidv4 } from "uuid";

const COUNTRY_CODE_JP = 'JP';
const COUNTRY_CODE_LOCAL_JP = '日本';
const COUNTRY_CODE_TW = 'TW';
const COUNTRY_CODE_LOCAL_TW = '台灣';
const COUNTRY_CODE_ME = 'AE';
const COUNTRY_CODE_LOCAL_ME = 'UAE';
const Verify: React.FC = () => {
  const { state } = useLocation();
  const { locale, localeWith_, defaultCurrency } = useLocalization();
  const userType = state ? state.user : sessionStorage.getItem('userType');
  const validations = state ? state.validationErrors : '';
  const navigate = useNavigate();
  const isThanks: boolean = false;
  const isVerify: boolean = true;
  const { t } = useTranslation();
  const googleKey = config.captchaKey;
  const captchaRef = useRef<ReCAPTCHA | null>(null);
  const [cartData, setCartData] = useState<CartData>();
  const [billingInfoName, setbillingInfoName] = useState('');
  const [billingInfoEmail, setbillingInfoEmail] = useState('');
  const [billingAddress, setbillingAddress] = useState('');
  const [billingCountry, setbillingCountry] = useState('');
  const [billingContact, setbillingContact] = useState('');
  const [shippingInfoName, setshippingInfoName] = useState('');
  const [shippingAddress, setshippingAddress] = useState('');
  const [shippingCountry, setshippingCountry] = useState('');
  const [shippingContact, setshippingContact] = useState('');
  const [shippingAttn, setShippingAttn] = useState('');
  const [couponCode, setCoupon] = useState<string | null>(null);
  const [isDisable, setIsDisable] = useState<boolean>(true);
  const [captchaScore, setCaptchaScore] = useState<number | undefined>(undefined);
  const { isLoading, showLoader, hideLoader, isCartLoading, hideCartLoader, showCartLoader, hideBodyLoader } = useLoader();
  const { setLoginStatus, setItemsInCart } = useHeaderMenu();
  const [validationErrors, setValidationErrors] = useState<Record<string, string>>(validations || {});
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [errorShippingMessage, setErrorShippingMessage] = useState<undefined | string>(undefined);
  const [errorCode, setErrorCode] = useState<null | string>(null);
  const [reCaptchaToken, setReCaptchaToken] = useState<string | null>(null);
  const { getCart, updateCart, submitOrder, submitCapatcha, getPaymentIntent } = useCart();
  const [disclaimerText, setDisclaimerText] = useState<string | null>(null);
  const [sanitizedText, setSanitizedText] = useState<string | null>(null);
  const [showSubmitOrderErrorModal, setShowSubmitOrderErrorModal] = React.useState(false);
  const [paymentIntent, setPaymentIntent] = useState<string | null>(null);
  const [localLoader, setLocalLoader] = useState<boolean>(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paymentIntentId = urlParams.get('payment-intent-id');
    if (paymentIntentId) {
      setPaymentIntent(paymentIntentId);
    }
  }, []);

  useEffect(() => {
    if (disclaimerText) {
      let discTxt = DOMPurify.sanitize(disclaimerText, {
        ALLOWED_TAGS: ['a'], // Allow anchor tags
        ALLOWED_ATTR: ['href', 'target', 'rel', 'class'], // Allow necessary attributes including target
      });
      setSanitizedText(discTxt);
    }
  }, [disclaimerText]);

  const handleCartChange = () => {
    console.log('handleCartChange===>', userType);
    if (nvCookieHelpers.getCookie('isUserLoggedIn')) {
      navigate(`/${locale}/cart/user/loggedIn?step=2`)
    } else {
      navigate(`/${locale}/cart/user/guest?step=2`)
    }
  }

  const handleEditAddress = () => {
    console.log('handleEditAddress===>', userType);
    if (nvCookieHelpers.getCookie('isUserLoggedIn')) {
      navigate(`/${locale}/cart/user/loggedIn?step=1`)
    } else {
      navigate(`/${locale}/cart/user/guest?step=1`)
    }
  }
  const captchaLanguage = locale.split('-')[0];
  const invalidKeywords = [
    "P O BOX",
    "PO BOX",
    "POBOX",
    "P. O. BOX",
    "P.O. BOX",
    "P.O.BOX",
    "Parcel Locker",
    "Parcel Collect",
    "Parcel",
    "PO",
    "Locker",
    "Packstation",
    "Pack Station",
    "FPO",
    "P.O BOX",
    "PO. BOX",
    "APO",
    "DPO",
    "Post Ofc Box",
    "Post office box",
    "Post Office",
    "PostOffice",
    "pob",
    "mailbox"
  ];

  const validateStringOrIntegerAddress = function (input: string, locale: string) {
    var trimmedInput = input.trim();
    if (locale === 'en-gb' || locale === 'es-mx') {
      return true;
    }
    // Check if the input contains only numbers
    if (/^\d+(\s+\d+)*$/.test(trimmedInput)) {
      return false; // Return false if the input contains only numbers
    }

    // Check if the input contains only alphabet letters and spaces without numbers
    if (/^[A-Za-z\s]+$/.test(trimmedInput) && !/\d/.test(trimmedInput)) {
      return false; // Return false if the input contains only letters and spaces
    }

    // Check if the input contains a mix of letters, numbers, and spaces
    if (/^[A-Za-z0-9\s]+$/.test(trimmedInput) && /\d/.test(trimmedInput) && /[A-Za-z]/.test(trimmedInput)) {
      return true; // Return true if the input is valid with letters and numbers
    }
    // If none of the above conditions are met, return true
    return true;
  };
  const validateAddress = (input) => {
    // Validate against invalid keywords
    for (const keyword of invalidKeywords) {
      const keywordRegex = new RegExp(`\\b${keyword}\\b`, 'i');
      if (keywordRegex.test(input)) {
        console.log(`Matching keyword: ${keyword}`);
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    if (!errorShippingMessage && !errorShippingMessage?.length) {
      if (userType === 'guest') {
        if (captchaScore) {
          setIsDisable(false);
          console.log(isDisable);
        } else {
          setIsDisable(true);
          console.log(isDisable);
        }
      } else {
        setIsDisable(false);
        console.log(isDisable);
      }
    } else {
      setIsDisable(true);
      console.log(isDisable);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [captchaScore, errorShippingMessage])
  const resetRecaptcha = () => {
    if (captchaRef.current) {
      captchaRef.current.reset();
      setCaptchaScore(undefined);
    }
  };
  const handleCaptchaError = useCallback(() => {
    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleCaptchaSuccess = useCallback((result) => {
    if (result.valid && result.score > 0.4 && !errorShippingMessage) {
      setCaptchaScore(result.score);
      console.log('handleCaptchaSuccess===>', result, errorShippingMessage);
    } else {
      resetRecaptcha();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleCaptchaTimeout = () => {
    resetRecaptcha();
  }
  const handleRecaptcha = async (token: string | null) => {
    setReCaptchaToken(token);
    // Send the token to your backend
    if (token) {
      let tokenObj = { "token": token, "siteKey": config.captchaKey, "expectedAction": "SUBMIT" }
      // Make an API request to your backend with the token
      // Example using fetch:
      await submitCapatcha(tokenObj, handleCaptchaSuccess, handleCaptchaError);
    }
  };
  const fieldNameRef = useRef<string | null>(null);
  const handleCouponDelete = (c: boolean = false) => {
    console.log('CouponDelete==>', c);
  }
  const handleCouponSubmit = (c: string) => {
    console.log('couponCode==>', couponCode, c);
    handleCartUpdate(undefined, undefined, undefined, c)
  }
  const handleCouponChange = (fieldName: string, promo: string) => {
    setCoupon(promo);
    fieldNameRef.current = fieldName;
  }
  const handleCouponError = () => {
    hideLoader();
  }
  const handleSuccess = useCallback((result) => {
    setCartData(result);
    setItemsInCart(result.totalItemsInCart);
    hideLoader();
    hideCartLoader();
    if (result?.locale) {
      const localeParts = result.locale.split('_');
      if (localeParts.length === 2) {
        const formattedResultLocale = `${localeParts[0]}-${localeParts[1].toLowerCase()}`;
        if (locale !== formattedResultLocale) {
          hideBodyLoader();
          navigate(`/${locale}/cart/empty`);
          return;
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleError = useCallback(() => {
    const emptyCart = (msg) => navigate(`/${locale}/cart/empty`, { state: { msg } });
    hideCartLoader();
    emptyCart(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, locale]);
  const handleCartUpdate = async (productId?: string, selectedOption?: number, shippingOption?: string, coupon?: string, couponApplied?: boolean) => {
    showCartLoader();
    if (productId && (selectedOption !== undefined && selectedOption !== null)) {
      await updateCart(handleSuccess, handleError, productId, selectedOption, shippingOption, undefined, undefined, false);
    } else if (shippingOption !== undefined && shippingOption !== null) {
      await updateCart(handleSuccess, handleError, undefined, undefined, shippingOption, undefined, undefined, false);
    } else {
      if (coupon) {
        await updateCart(handleSuccess, handleCouponError, undefined, undefined, undefined, coupon, undefined, false);
      } else {
        if (couponApplied) {
          await updateCart(handleSuccess, handleCouponError, undefined, undefined, undefined, undefined, undefined, couponApplied);
        }
      }
    }
    hideCartLoader();
  };
  const thankyou = useCallback((cartResult) => {
    navigate(`/${locale}/cart/thankyou`, { state: { cartResult } });
  },
    [navigate, locale]
  );
  useEffect(() => {
    console.log("shippingAddress===>", shippingAddress);
    if (shippingAddress.length && !validateStringOrIntegerAddress(shippingAddress as string, locale)) {
      const validationResult = t('ADDRESS_UNDELIVERABLE');
      setErrorShippingMessage(validationResult);
    } else {
      if (!shippingAddress.length) {
        setErrorShippingMessage(t('ADDRESS_SHIPPING_RESTRICTIONS'));
      } else if (!validateAddress(shippingAddress as string)) {
        setErrorShippingMessage(t('ADDRESS_NOT_SHIPPABLE'));
      } else {
        setErrorShippingMessage(undefined);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shippingAddress])
  const handlePaymentIntentSuccess = (result) => {
    console.log('HANDLE PAYMENT INTENT SUCCESS===>', result);
    if (result.payment_intent_id) {
      setPaymentIntent(result.payment_intent_id);
    } else {
      submitOrder(handleOrderSuccess, handleOrderError, true);
    }
    setLocalLoader(true);
    hideLoader();
  };


  const handleOrderSuccess = useCallback((result) => {
    console.log('HANDLE SUCCESS===>', result?.order?.orderState)
    sessionStorage.setItem('isPlaced', 'true');
    const cartResult = {
      ...result,
      brand: result?.brand ?? cartData?.brand,
    };
    thankyou(cartResult);
  }, [thankyou, cartData?.brand]);

  const handleOrderError = useCallback((error: any) => {
    setErrorCode(error?.code);
    setErrorMessage(error?.description);
    setCaptchaScore(undefined);
    // Retrieve the description from the error and update the error message
    const description = error?.description;
    const newValidationErrors = { ...validationErrors }; // Clone the current errors
    console.log('validations==>', validations);
    const emptyCart = (msg: string) => navigate(`/${locale}/cart/empty`, { state: { msg } });
    hideLoader();
    setLocalLoader(false);
    if (error?.code === "ENTITLEMENT_VALIDATION_FAILED") {
      setErrorCode(error?.code);
      setErrorMessage(description);
    } else if (error?.code === 'inventory-unavailable-error') {
      hideCartLoader();
      emptyCart(description);
    } else if (error?.code === 'CART_PAYMENT_FAILURE') {
      hideCartLoader();
      const paymentErrorMsg = error?.ucpError?.metadata?.message || t('CART_PAYMENT_FAILURE');
      newValidationErrors['paymentErr'] = paymentErrorMsg;
      setErrorMessage(paymentErrorMsg);
      return;
    } else if (error?.code === 'restricted-bill-to-country' || error?.code === 'country_restricted' || error?.code === 'invalid_shipping_choice' || error?.code === 'restricted-ship-to-country') {
      const invalidhip = () => navigate(`/${locale}/cart/invalidShipping`);
      hideCartLoader();
      invalidhip();
    } else {
      hideCartLoader();
      setShowSubmitOrderErrorModal(true);
      //emptyCart(t('VERIFY_PAGE_ERROR_MESSAGE'));
    }
    // Update validationErrors state with the new error
    setValidationErrors(newValidationErrors);
    setErrorMessage(t(error?.code?.replace(/-/g, '_')?.toUpperCase()));
    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const placeOrder = async () => {
    showLoader();
    console.log('reCaptchaToken===>', reCaptchaToken);
    const token = captchaRef.current?.getValue();
    console.log('captchaToken===>', token);
    try {
      await getPaymentIntent(handlePaymentIntentSuccess, handleOrderError);

      //await submitOrder(handleOrderSuccess, handleOrderError);
    } catch (error) {
      console.log('CATCH')
      hideLoader();
      console.error(error);
      return null; // Return null in case of an error
    }
  }

  const fetchData = async () => {
    showLoader();
    try {
      const response = await getCart(handleSuccess, handleError, false);
      // Access the recaptchaValue directly
      hideLoader();
      hideBodyLoader();
      return response; // Return the fetched data
    } catch (error) {
      hideLoader();
      console.error(error);
      return null; // Return null in case of an error
    }
  };

  // Monitor page visibility to detect when page becomes active again
  useEffect(() => {
    const handleVisibilityChange = () => {
      // When page becomes visible again, check if token is expired
      if (!document.hidden && cartData?.idt) {
        if (isJwtTokenExpired(cartData.idt)) {
          console.warn("JWT token (idt) is expired after page became active. Refreshing page to reinitialize.");
          window.location.reload();
        }
      }
    };

    // Listen for visibility changes
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup listener on unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [cartData?.idt]);

  useEffect(() => {
    if (cartData?.totalItemsInCart) {
      // Check if idt token exists and is expired
      if (cartData?.idt && isJwtTokenExpired(cartData.idt)) {
        console.warn("JWT token (idt) is expired. Refreshing page to reinitialize.");
        // Refresh the page to reinitialize everything with a fresh token
        window.location.reload();
        return;
      }

      let originEnvironment = window.location.origin
        .split("/")[2]
        .split("-")[0]
        ?.toUpperCase();
      originEnvironment =
        originEnvironment !== "STG" && originEnvironment !== "DEV"
          ? "PROD"
          : originEnvironment;

      initialize({
        version: "v1",
        environment: originEnvironment as any,
        clientId: "nvstore",
      })
        .then((Ucp) => {
          let initEnvironment =
            originEnvironment === "DEV"
              ? `${originEnvironment}_UE1`
              : originEnvironment;

          const initOptions = {
            ...((!cartData?.idt) && {
              guestSessionId: cartData?.paymentSession?.id,
            }),
            ...(cartData?.idt && { token: cartData?.idt }),
            environment: initEnvironment as EnvironmentAPI,
            theme: "light" as Theme,
            nonce: uuidv4(),
            locale: localeWith_,
            currency: defaultCurrency.toLowerCase(),
            clientFlavor: "public",
          };
          Ucp.initialize(initOptions);
          window.Ucp?.events?.addEventListener('event-finalize-payment', (event: any) => {
            console.log('Finalize payment event:', event.detail.message);
            setPaymentIntent(null);
            switch (event.detail.message) {
              case 'CONFIRM_PAYMENT_SUCCESS':
              case 'CONFIRM_PAYMENT_ALREADY_SUCCEEDED_REDIRECT':
                submitOrder(handleOrderSuccess, handleOrderError, true);
                showLoader();
                break;
              case 'ALERT':
                submitOrder(handleOrderSuccess, handleOrderError, false, event?.detail);
                showLoader();
                // setLocalLoader(false);
                // setPaymentError(t('CART_PAYMENT_FAILURE'));

                break;
            }
          });
        })
        .catch((error) => {
          console.error("Failed to initialize UCP:", error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData, localeWith_, defaultCurrency, cartData?.idt, cartData?.paymentSession?.id]);


  useEffect(() => {
    const getCartData = async () => {
      const response = await fetchData();
      if (response) {
        setCartData(response);
        hideLoader();
        hideBodyLoader();
      }
    };
    if (!cartData) {
      if (nvCookieHelpers.getCookie('isUserLoggedIn') && userType === 'loggedIn') {
        setLoginStatus(true);
      }
      getCartData();
    } else {
      let infoNameBilling = (cartData.billingAddress?.firstName || '') + ' ' + (cartData.billingAddress?.lastName || '');
      let addressBilling =
        (cartData.billingAddress?.line1 ? cartData.billingAddress?.line1 + ', ' : '') +
        (cartData.billingAddress?.line2 ? cartData.billingAddress?.line2 + ', ' : '') +
        (cartData.billingAddress?.city ? cartData.billingAddress?.city + ', ' : '') +
        (cartData.billingAddress?.countrySubdivision && locale !== 'zh-tw' ? cartData.billingAddress?.countrySubdivision + ', ' : '') +
        ((locale !== 'en-hk' && locale !== 'en-me') ? cartData.billingAddress?.postalCode : '');

      let infoNameShipping = (cartData.shippingAddress?.firstName || '') + ' ' + (cartData.shippingAddress?.lastName || '');
      let addressShipping =
        (cartData.shippingAddress?.line1 ? cartData.shippingAddress?.line1 + ', ' : '') +
        (cartData.shippingAddress?.line2 ? cartData.shippingAddress?.line2 + ', ' : '') +
        (cartData.shippingAddress?.city ? cartData.shippingAddress?.city + ', ' : '') +
        (cartData.shippingAddress?.countrySubdivision && locale !== 'zh-tw' ? cartData.shippingAddress?.countrySubdivision + ', ' : '') +
        ((locale !== 'en-hk' && locale !== 'en-me') ? cartData.shippingAddress?.postalCode : '');


      if (locale === 'ja-jp') {
        infoNameBilling = (cartData.billingAddress?.lastName || '') + ' ' + (cartData.billingAddress?.firstName || '');
        addressBilling =
          (cartData.billingAddress?.postalCode + ' ' || '') +
          (cartData.billingAddress?.countrySubdivision ? cartData.billingAddress?.countrySubdivision + ', ' : '') +
          (cartData.billingAddress?.city ? cartData.billingAddress?.city + ', ' : '') +
          (cartData.billingAddress?.line1 ? cartData.billingAddress?.line1 : '') +
          (cartData.billingAddress?.line2 ? ', ' + cartData.billingAddress?.line2 : '');
        infoNameShipping = (cartData.shippingAddress?.lastName || '') + ' ' + (cartData.shippingAddress?.firstName || '');
        addressShipping =
          (cartData.shippingAddress?.postalCode + ' ' || '') +
          (cartData.shippingAddress?.countrySubdivision ? cartData.shippingAddress?.countrySubdivision + ', ' : '') +
          (cartData.shippingAddress?.city ? cartData.shippingAddress?.city + ', ' : '') +
          (cartData.shippingAddress?.line1 ? cartData.shippingAddress?.line1 : '') +
          (cartData.shippingAddress?.line2 ? ', ' + cartData.shippingAddress?.line2 : '');
      }
      const items = cartData?.cartItems.cartItem.map((cartItem) => ({
        quantity: cartItem.quantity,
        price: {
          basePrice: parseFloat(cartItem.pricing.formattedListPrice.replace('$', '')), // Convert to number
          discount: 0, // Assuming no discount information is present
        },
        productInfo: {
          sku: `sku-${cartItem.product.id}`, // Generate SKU from product ID if no SKU exists
          prodID: cartItem.product.id.toString(),
          productName: cartItem.product.name,
        },
      }));
      const formattedLocale = locale.replace('-', '_').toLowerCase().replace(/^[a-z]{2}/, match => match.toUpperCase());
      const cart = {
        customerID: "",
        orderID: cartData ? cartData['cartId'] : '',
        currencyCode: cartData ? cartData['pricing']['orderTotal']['currency'] : '',
        loginState: nvCookieHelpers.getCookie('isUserLoggedIn') ? 'loggedIn' : 'guest',
        storeLocale: formattedLocale,
        promoCode: "no",
        saveCardOption: false, // Assuming this is a boolean
        shippingMethod: cartData ? cartData['shippingMethod']['description'] : "",
        items: items
      }
      if (typeof window !== "undefined") {
        (window as any).CartOrder = cart;
      }
      console.log((window as any).CartOrder);
      setbillingInfoName(infoNameBilling);
      setbillingAddress(addressBilling);
      setbillingInfoEmail(cartData.billingAddress?.emailAddress || '');
      setbillingCountry(cartData.billingAddress?.country === COUNTRY_CODE_JP ? COUNTRY_CODE_LOCAL_JP : cartData.billingAddress?.country === COUNTRY_CODE_TW ? COUNTRY_CODE_LOCAL_TW : cartData.billingAddress?.country === COUNTRY_CODE_ME ? COUNTRY_CODE_LOCAL_ME : cartData.billingAddress?.country || '');
      setbillingContact(locale === 'zh-tw' ? sanitizePhoneNo(cartData.billingAddress?.phoneNumber) : formatPhoneNoInReadableForm(sanitizePhoneNo(cartData.billingAddress?.phoneNumber), locale));
      setshippingInfoName(infoNameShipping);
      setshippingAddress(addressShipping);
      setshippingCountry(cartData.shippingAddress?.country === COUNTRY_CODE_JP ? COUNTRY_CODE_LOCAL_JP : cartData.shippingAddress?.country === COUNTRY_CODE_TW ? COUNTRY_CODE_LOCAL_TW : cartData.shippingAddress?.country === COUNTRY_CODE_ME ? COUNTRY_CODE_LOCAL_ME : cartData.shippingAddress?.country || '');
      setshippingContact(locale === 'zh-tw' ? sanitizePhoneNo(cartData.shippingAddress?.phoneNumber) : formatPhoneNoInReadableForm(sanitizePhoneNo(cartData.shippingAddress?.phoneNumber), locale));
      setShippingAttn(cartData.shippingAddress?.attn || '');
    }
    setDisclaimerText(t('CONFIRM_DISCLAIMER'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData]);
  return (
    <div className="Verify">
      {isLoading}
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {localLoader && <Spinner />}
          <Container className="verifyWrapper" role="main" aria-labelledby="verify-page-heading">
            <Row xs={'auto'} md={'auto'}>
              <Col md={"7"} sm={"auto"} className="w100" role="region" aria-labelledby="cartSectionHeader">
                <h3 id="cartSectionHeader" className="visually-hidden">{t('SHOPPING_CART_HEADER')}</h3>
                <div id="ShopperInformation" role="region" aria-labelledby="shopper-information-heading">
                  <h3 id="shopper-information-heading" className="visually-hidden">{t('SHOPPER_INFORMATION')}</h3>
                  <span className={`${(errorCode === 'internal-payment-error' ||
                    errorCode === 'ENTITLEMENT_VALIDATION_FAILED') ? "is-invalid" : ""}`} />
                  <Form.Control.Feedback type="invalid" aria-live="assertive">{errorMessage}</Form.Control.Feedback>
                  <h2 id="verify-page-heading" className="pageHeading">{t('BTN_REVIEW_ORDER')}</h2>
                  <Card id="ShoppingCartMobile">
                    <div className={isCartLoading ? `cart-loading` : ''}>
                      {isCartLoading && <Image src={cartLoader} className="cartLoader" alt={t('CART_LOADING')} aria-live="polite"></Image>}
                      {cartData && (
                        <Cart onCartChange={handleCartChange} validationErrors={validations} onPromoChange={handleCouponChange} onPromoSubmit={handleCouponSubmit} onPromoDelete={handleCouponDelete} isThanks={isThanks} isVerify={isVerify} cartData={cartData} promoCodeError={false} />
                      )}
                    </div>
                  </Card>
                  {cartData && (<Row xs={'auto'} md={'auto'} className="heightInherit">
                    {userType === 'guest' && (<Col md={12}>
                      <div id="contactInfo" className="dr_confirmElement" role="region" aria-labelledby="contact-info-heading">
                        <h3 id="contact-info-heading">{t('DR_CONTACT_INFORMATION_PAGE_TITLE')}</h3>
                        <address>
                          <span>{billingInfoEmail}</span>
                        </address>
                        <button
                          type="button"
                          onClick={handleCartChange}
                          className="continue editButton"
                          aria-label={`${t('BTN_EDIT_CAPS')} ${t('DR_CONTACT_INFORMATION_PAGE_TITLE')}`}
                        >
                          {t('BTN_EDIT_CAPS')}
                        </button>
                      </div>
                    </Col>)}
                    <Col md={6}>
                      <div className="billingInfo mb-4" role="region" aria-labelledby="billing-info-heading">
                        <h3 id="billing-info-heading" className="billingInfo">{t('BILLING_INFORMATION')}</h3>
                        <address>
                          <span className={`${errorCode === 'invalid-bill-to-country' ? "is-invalid" : ""}`}>
                            <p className="billingInfoName">
                              {billingInfoName}
                            </p>
                            <p className="billingAddress">
                              {billingAddress}
                            </p>
                            <p className="billingCountry">{billingCountry}</p>
                            <span className="billingContact">{billingContact}</span>
                          </span>
                          <Form.Control.Feedback type="invalid" aria-live="assertive">{errorMessage}</Form.Control.Feedback>
                        </address>
                        <button
                          type="button"
                          onClick={handleEditAddress}
                          className="continue editButton"
                          aria-label={`${t('BTN_EDIT_CAPS')} ${t('BILLING_INFORMATION')}`}
                        >
                          {t('BTN_EDIT_CAPS')}
                        </button>
                      </div>
                      {
                        cartData.taxExemption && cartData.taxExemption.companyName && cartData.taxExemption.vatNo && (
                          <div className="vatExemptionInfo mb-4" role="region" aria-labelledby="vat-exemption-heading">
                            <h3 id="vat-exemption-heading" className="vatExemption">{t('VAT_EXEMPTION')}</h3>
                            <address>
                              <span>

                                <p className="companyName">
                                  {cartData.taxExemption.companyName}
                                </p>
                                <p className="vatNo">{cartData.taxExemption.vatNo}</p>

                              </span>

                            </address>
                            <button
                              type="button"
                              onClick={handleCartChange}
                              className="continue editButton"
                              aria-label={`${t('BTN_EDIT_CAPS')} ${t('VAT_EXEMPTION')}`}
                            >
                              {t('BTN_EDIT_CAPS')}
                            </button>
                          </div>
                        )}
                      <div className="shipingInfo mb-4" role="region" aria-labelledby="shipping-info-heading">
                        <h3 id="shipping-info-heading" className="shipingInfo">{t('SHIPPING_INFORMATION')}</h3>
                        <address>
                          {shippingAddress && shippingInfoName && shippingCountry && (<span className={`${(errorShippingMessage || (errorCode === 'invalid-ship-to-country')) ? "is-invalid" : ""}`}>
                            <p className="shippingInfoName">
                              {shippingInfoName}
                            </p>
                            {shippingAttn && (
                              <p className="shippingAttn">
                                {t("ATTN")}: {shippingAttn}
                              </p>
                            )}
                            <p className="shippingAddress">
                              {shippingAddress}
                            </p>
                            <p className="shippingCountry">{shippingCountry}</p>
                            <span className="shippingContact">{shippingContact}</span>
                          </span>)}
                          <Form.Control.Feedback type="invalid" aria-live="assertive">{errorShippingMessage ? errorShippingMessage : errorMessage}</Form.Control.Feedback>
                        </address>
                        <button
                          type="button"
                          onClick={handleEditAddress}
                          className="continue editButton"
                          aria-label={`${t('BTN_EDIT_CAPS')} ${t('SHIPPING_INFORMATION')}`}
                        >
                          {t('BTN_EDIT_CAPS')}
                        </button>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="paymentInfo mb-4" role="region" aria-labelledby="payment-info-heading">
                        <h3 id="payment-info-heading" className="paymentInfo">{t('PAYMENT_METHOD')}</h3>
                        <address>
                          <span className={`${errorCode === 'CART_PAYMENT_FAILURE' ? "is-invalid" : ""}`}>
                            {
                              // nvCookieHelpers.getCookie('isUserLoggedIn') === 'true' ? (<cart-selected-payment-method payment-config="nvstore-standard-payments"></cart-selected-payment-method>) : (<guest-selected-payment-method payment-config="nvstore-standard-payments" ></guest-selected-payment-method>)
                              nvCookieHelpers.getCookie('isUserLoggedIn') === 'true' ? (<cart-selected-payment-method ></cart-selected-payment-method>) : (<guest-selected-payment-method ></guest-selected-payment-method>)
                            }
                          </span>
                          <Form.Control.Feedback type="invalid" aria-live="assertive">{errorShippingMessage ? errorShippingMessage : errorMessage}</Form.Control.Feedback>

                        </address>
                        <button
                          type="button"
                          onClick={handleCartChange}
                          className="continue"
                          aria-label={`${t('BTN_EDIT_CAPS')} ${t('PAYMENT_METHOD')}`}
                        >
                          {t('BTN_EDIT_CAPS')}
                        </button>
                      </div>
                    </Col>
                    {paymentIntent && (
                      <Col md={12} key={paymentIntent}>
                        <finalize-payment
                          payment-intent={paymentIntent}
                          return-url={`${window.location.origin}/${locale}/cart/verify/?payment-intent-id=${paymentIntent}`}
                        ></finalize-payment>
                      </Col>
                    )}
                    <Col md={12} className="orderDisclaimer mb-4" role="region" aria-labelledby="disclaimer-heading">
                      <h4 id="disclaimer-heading" className="visually-hidden">{t('ORDER_DISCLAIMER')}</h4>
                      <div className="dr_label" role="contentinfo" aria-label={sanitizedText || t('ORDER_DISCLAIMER')}>
                        <span
                          dangerouslySetInnerHTML={{ __html: sanitizedText || '' }}
                          aria-describedby="disclaimer-heading"
                        />
                      </div>
                    </Col>
                    {(userType === 'guest') && (
                      <Col md={{ span: 8, offset: 4 }} className="p-0">
                        <div className="captchaWrapper" role="region" aria-labelledby="captcha-heading">
                          <h4 id="captcha-heading" className="visually-hidden">
                            {t('SECURITY_VERIFICATION')}
                          </h4>

                          {/* Wrap reCAPTCHA in a div with aria-labelledby to provide accessible label */}
                          <div role="group" aria-labelledby="captcha-heading">
                            <label htmlFor="g-recaptcha-response" className="visually-hidden">
                              {t('SECURITY_VERIFICATION')}
                            </label>
                            <ReCAPTCHA
                              ref={captchaRef}
                              sitekey={googleKey}
                              size="normal"
                              hl={captchaLanguage}
                              onChange={(value) => handleRecaptcha(value)}
                              onExpired={handleCaptchaTimeout}
                            />
                          </div>
                        </div>
                      </Col>

                    )}
                    <Col md={{ span: 4, offset: 8 }}>
                      <Button
                        type="button"
                        variant="success"
                        className="btn-green submitOrder"
                        id="orderOmniClick"
                        data-product-id=""
                        onClick={placeOrder}
                        disabled={isDisable}
                        aria-label={t('BTN_PLACE_ORDER')}
                        aria-describedby={isDisable ? "order-disabled-reason" : undefined}
                      >
                        {t('BTN_PLACE_ORDER')}
                      </Button>
                      {isDisable && (
                        <div id="order-disabled-reason" className="visually-hidden" aria-live="polite">
                          {t('ORDER_BUTTON_DISABLED')}
                        </div>
                      )}
                    </Col>
                  </Row>)}
                </div>
              </Col>
              <Col md={"5"} sm={"auto"} className="w100" role="complementary" aria-labelledby="order-summary-heading">
                <Card id="ShoppingCart" className="reviewOrder">
                  <h3 id="order-summary-heading" className="visually-hidden">{t('ORDER_SUMMARY')}</h3>
                  {cartData && (
                    <Cart onCartChange={handleCartChange}
                      validationErrors={validations}
                      onPromoChange={handleCouponChange}
                      onPromoSubmit={handleCouponSubmit}
                      onPromoDelete={handleCouponDelete}
                      isVerify={isVerify}
                      isThanks={isThanks}
                      cartData={cartData}
                      promoCodeError={false}
                    />
                  )}
                </Card>
              </Col>
            </Row>
            <ErrorModal
              show={showSubmitOrderErrorModal}
              onHide={() => setShowSubmitOrderErrorModal(false)}
            />
          </Container>
        </>
      )}
    </div>
  );
};
export default Verify;